import { Injectable } from '@angular/core';
import { Toast } from '../models/toast.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: Toast[] = [];

  add(message: string, type: 'success' | 'error' | 'info', duration: number) {
    this.toasts.push({ message, type });
    setTimeout(() => this.toasts.shift(), duration);
  }

  success(message: string, duration = 5000) {
    this.add(message, 'success', duration);
  }

  error(message: string, duration = 5000) {
    this.add(message, 'error', duration);
  }

  info(message: string, duration = 5000) {
    this.add(message, 'info', duration);
  }

  remove(index: number) {
    this.toasts.splice(index, 1);
  }
}
